module.exports = __webpack_public_path__ + "img/icon_teamculture.156e6e24.svg";